import * as Yup from 'yup';

export const businessTypeValidator = Yup.object().shape({
  companyType: Yup.string().required('Company type is required'),
});
